import qs from 'qs';
import { IApp } from './../../types.d';
import {
  createFrame,
  getBaseUrl,
  resolveUrl,
  startRequest,
} from './helpers';
import { ensureUrlEndsWithIndexHtml } from 'lib/strings';

/**
 * Base Strategy
 * @param strategy
 */
export const BaseStrategy = function (strategy = null) {
  this.strategy = strategy;
};

BaseStrategy.prototype = {
  setStrategy: function (strategy) {
    this.strategy = strategy;
  },

  launch: function (data) {
    return this.strategy.launch(data);
  },
};

/**
 * ExternalAppStrategy: open an app in a new tab
 */
export const ExternalAppStrategy = function (token: string = '') {
  this.launch = function (data: IApp) {
    console.log('using ... ExternalAppStrategy.launch', { data, token });
    const queryString = qs.stringify({
      ...data.queryParams,
      // NOTE: needs saranno aggiunti all'url
      // usare data.needs per sapere quali altri params vanno aggiunti
      //token,
    });
    const url = `${data.uri}?${queryString}`;
    // console.log({ url });

    // open new tab
    window.open(url, '_blank');
  };
};

/**
 * IFrameSrcSamePageStrategy
 */
export const IFrameSrcStrategy = function (token: string = '') {
  this.launch = function (data: IApp) {
    console.log('using ... IFrameSrcStrategy.launch', { data });
    // console.log({ uri: data.uri });
    // console.log('data' + JSON.stringify(data));
    console.log('IFrameSrcStrategy data ' + JSON.stringify(data));

    // createFrame({ ...data /* , token */ }, 'test');
    createFrame({ ...data /* , token */ });
    // createAsyncFrame({ ...data, token });
  };
};

export const IFrameDocStrategy = function (token: string = '') {
  this.launch = async function (data: IApp) {
    console.log('using ... IFrameDocStrategy.launch', { data });

    const completeUrl = resolveUrl(data.uri);

    const result = await startRequest(
      { method: 'get', url: completeUrl },
      token,
    );

    // console.log({ completeUrl });

    createFrame({ ...data, srcdoc: result });
  };
};

export const NewPageStrategy = function () {
  this.launch = function (data: IApp) {
    console.log('using ... NewPageStrategy.launch', { data });
    const baseUrl = getBaseUrl();
    const url = `${baseUrl}/#${data.code}`;
    window.open(url, '_blank');
  };
};

export const SamePageStrategy = function () {
  this.launch = function (data: IApp) {
    console.log('using ... SamePageStrategy.launch', JSON.stringify({ data }));
    let baseUrl = getBaseUrl();
    baseUrl = ensureUrlEndsWithIndexHtml(baseUrl);
    const url = `${baseUrl}#${data.code}`;
    console.log(`SamePageStrategy.launch "${url}"`);
    window.location.replace(url);
    window.location.reload();
  };
};
